import { config } from './config';
import { resolveParentOrigin } from './resizeBridge';

// Conversion tracking bridge (Marketing / Micky).
//
// The widget lives in an iframe, so it cannot touch the parent page's Google Tag
// Manager dataLayer directly. Instead we postMessage a single, well-defined event
// to the embedding WordPress page; a small snippet there pushes it into the
// dataLayer (see embed/randori-form-embed.html). All pixel mapping (Meta, TikTok,
// Google) happens in GTM on the parent side — we only emit the raw signal.
//
// `test: true` is included on every event so GTM can exclude test-mode submits
// (?test=1) from real conversion reporting.
export type TrackEvent = 'lead' | 'booking' | 'callback';

export function trackEvent(event: TrackEvent, data: Record<string, unknown> = {}): void {
  try {
    window.parent.postMessage(
      { type: 'randori-form-event', event, test: config.isTest, ...data },
      resolveParentOrigin(),
    );
  } catch {
    /* tracking must never break the form flow */
  }
}
